import React from 'react'
import logo from '../../images/billy_logo_inverted.svg'
import { Link } from 'react-router-dom'

interface LogoProps {
	height?: string | number
}

const Logo = (props: LogoProps) => {
	return (
		<Link to="/">
			<img src={logo} {...props} />
		</Link>
	)
}

export default Logo
